
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, tap, take } from 'rxjs/operators';
import { GameCategoryEntityService } from '@core/services/games/gamecategory-entity.service';


@Injectable()
export class GameCategoryResolver implements Resolve<boolean> {

    constructor(private gameCategoryEntityService: GameCategoryEntityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.gameCategoryEntityService.loaded$.pipe(
          tap(loaded =>  {
            if (!loaded) {
              this.gameCategoryEntityService.getAll().pipe(
                take(1)
              );
            }
          }),
          filter(loaded => !!loaded),
          first()
        );
    }
}
